interface Criterion { label: string; met: boolean }

function checkPw(pw: string) {
  const criteria: Criterion[] = [
    { label: 'At least 12 characters', met: pw.length >= 12 },
    { label: 'One number',             met: /\d/.test(pw) },
    { label: 'One symbol',             met: /[^\w\s]/.test(pw) },
    { label: 'Mixed case (recommended)', met: /[a-z]/.test(pw) && /[A-Z]/.test(pw) },
  ]
  const met = criteria.filter((c) => c.met).length
  const level: 'weak' | 'fair' | 'good' | 'strong' =
    met <= 1 ? 'weak' : met === 2 ? 'fair' : met === 3 ? 'good' : 'strong'
  const label = level === 'weak' ? 'Weak' : level === 'fair' ? 'Fair' : level === 'good' ? 'Good' : 'Strong'
  return { level, label, criteria }
}

const CheckIcon = () => (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"><polyline points="5 13 10 18 19 7"/></svg>)
const CircleIcon = () => (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="9"/></svg>)

export function PasswordStrength({ password }: { password: string }) {
  const { level, label, criteria } = checkPw(password)
  return (
    <div className={`pw-strength pw-strength--${level}`}>
      <div className="pw-strength__bar">
        <span className="pw-strength__segment" />
        <span className="pw-strength__segment" />
        <span className="pw-strength__segment" />
        <span className="pw-strength__segment" />
      </div>
      <div className="pw-strength__label-row">
        <span className="pw-strength__label">Password strength</span>
        <span className="pw-strength__value">{label}</span>
      </div>
      <ul className="pw-strength__criteria">
        {criteria.map((c) => (
          <li key={c.label} className={c.met ? 'pw-strength__criterion pw-strength__criterion--met' : 'pw-strength__criterion'}>
            {c.met ? <CheckIcon /> : <CircleIcon />}
            {c.label}
          </li>
        ))}
      </ul>
    </div>
  )
}
